import { render, staticRenderFns } from "./POIStepsWrapper.vue?vue&type=template&id=4abcd2a0"
import script from "./POIStepsWrapper.js?vue&type=script&lang=js&external"
export * from "./POIStepsWrapper.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports